import { gql } from '@apollo/client'
import { PACKAGING_FRAGMENT } from './PackagingFragment'

export const MULTI_PRODUCT_IMAGE_PRODUCT_FRAGMENT = gql`
  fragment MultiProductImageProduct on Product {
    id
    created
    modified
    upcA
    name
    brand {
      id
      name
    }
    flavors {
      id
      flavor
      displayFlavor
    }
    packaging {
      ...Packaging
    }
    marketingImageUrl
    verifiedBy
  }
  ${PACKAGING_FRAGMENT}
`
